import useUser from '@vl-core/hooks/useUser';

const useIsAutomationTestUser = () => {
  const user = useUser();

  return !!user.test_account;
};

export default useIsAutomationTestUser;
